import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useHistory } from "react-router-dom";
import { CalendarServiceInstance, displayStatus, formatTimeRange, serviceColour } from "./calendarUtils";

interface Props { instance: CalendarServiceInstance; onOpen: (instance: CalendarServiceInstance) => void; compact?: boolean; }

export default function CalendarEventCard({ instance, onOpen, compact }: Props) {
  const history = useHistory();
  const status = displayStatus(instance);
  const hasBookings = instance.capacity != null || instance.bookedCount != null;
  const openCampaign = (type: "PreRegistration" | "PostRegistration", campaignId?: number | null) => {
    const query = campaignId
      ? `campaignId=${campaignId}`
      : `create=true&serviceId=${instance.serviceId}&serviceInstanceId=${instance.serviceInstanceId}&communicationType=${type}`;
    history.push(`/manage-campaigns?${query}`);
  };
  return (
    <div className={`calendar-event-card${compact ? " calendar-event-card--compact" : ""}`} style={{ ["--service-colour" as string]: serviceColour(instance) }}>
      <button type="button" className="calendar-event-card-open" onClick={() => onOpen(instance)} aria-label={`Open ${instance.serviceName}, ${formatTimeRange(instance)}`}>
        <div className="calendar-event-card-main">
        <div className="calendar-event-card-top"><span>{formatTimeRange(instance)}</span><span className={`calendar-status calendar-status--${status.toLowerCase().replace(/\s+/g, "-")}`}>{status}</span></div>
        <strong>{instance.serviceName}</strong>
        {!compact && instance.venue && <span className="calendar-event-meta"><LocationOnOutlinedIcon />{instance.venue}</span>}
        {!compact && hasBookings && <span className="calendar-event-meta"><GroupsOutlinedIcon />{instance.bookedCount ?? 0} booked{instance.capacity != null ? ` / ${instance.capacity} capacity` : ""}</span>}
        </div>
        <ChevronRightIcon className="calendar-event-chevron" aria-hidden="true" />
      </button>
      {!compact && <div className="calendar-event-campaigns" aria-label="Session communications">
        <MailOutlineIcon aria-hidden="true" />
        <button type="button" className={instance.preRegistrationCampaignId ? "is-configured" : ""} onClick={() => openCampaign("PreRegistration", instance.preRegistrationCampaignId)} title={instance.preRegistrationCampaignName ?? "Add pre-registration campaign"}>Pre {instance.preRegistrationCampaignId ? "set" : "+"}</button>
        <button type="button" className={instance.postRegistrationCampaignId ? "is-configured" : ""} onClick={() => openCampaign("PostRegistration", instance.postRegistrationCampaignId)} title={instance.postRegistrationCampaignName ?? "Add post-registration auto reply"}>Post {instance.postRegistrationCampaignId ? "set" : "+"}</button>
      </div>}
    </div>
  );
}
